import React from 'react';
import classNames from 'classnames/bind';
import { subStylesHrefByName } from '@constants/subStyles';

import { IDesignerProfile, IDesignerSubStyle } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';
import DesignerVideo from '../DesignerVideo';

import Testimonial from './Testimonial';

import styles from './DesignerBio.module.scss';

const cx = classNames.bind(styles);

interface IDesignerBioProps {
  className?: string;
  designer: IDesignerProfile;
}

const DesignerBio = ({
  className = '',
  designer: {
    designAesthetic = '',
    favoritePiece,
    favoriteSubStyles = [],
    firstName,
    id: designerId,
    lastName,
    loveDesign = '',
    testimonials = [],
    youtubeId = ''
  }
}: IDesignerBioProps) => {
  const getStyleList = () => {
    return favoriteSubStyles.map(({ id, name }: IDesignerSubStyle) => (
      <a
        className={ styles.StyleTag }
        href={ subStylesHrefByName[name] }
        key={id}
      >
        <span>{name}</span>
      </a>
    ));
  };

  const classNameRoot = cx(className, {
    Root: true,
    hasNoVideo: !youtubeId
  });

  return (
    <div className={ classNameRoot }>
      <div className={ styles.Inner }>
        <div className={ styles.DesignerVideoWrapper }>
          <DesignerVideo
            designerId={designerId}
            firstName={firstName}
            lastName={lastName}
            youtubeId={youtubeId}
          />
        </div>

        <div className={ styles.DesignerBioWrapper }>
          {
            (!!favoriteSubStyles?.length) && (
              <>
                <h3>Design Aesthetic</h3>
                <p>
                  <div className={ styles.StyleList }>
                    { getStyleList() }
                  </div>
                </p>
                <p>{ designAesthetic }</p>
              </>
            )
          }

          {
            !!favoritePiece && (
              <>
                <h3>Favorite Piece</h3>
                <p>{ favoritePiece }</p>
              </>
            )
          }

          {
            !!loveDesign && (
              <>
                <h3>Why I Love Online Interior Design</h3>
                <p>{ loveDesign }</p>
              </>
            )
          }

          {
            !!testimonials?.length && (
              <>
                <h3>Happy Clients</h3>
                {testimonials.map((props: any) => <Testimonial {...props} />)}
              </>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default DesignerBio;
